import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const PromoCodes = () => import('./views/Index.vue');

export default [
  {
    path: '/promo-codes',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'PromoCodes',
        component: PromoCodes,
        meta: { title: i18n.global.t('promoCodes.promoCodes') },
      },
    ],
  },
];
